import { callApiWithData } from '../../../api/call-api';
import Meal, { mapMealFromApi } from '../../../models/meal';
import MealForm from '../MealForm';
import { callRecipeFromImageApi } from '../../../api/assistant-api';
import { createIngredientInputItem, IngredientInputItem } from '../Ingredient/IngredientInput';
import { resolveIngredientIds } from '../../../api/ingredient-api';

interface EditMealProps {
  mealToEdit: Meal;
  onMealSave: (meal: Meal) => void;
}

const EditMeal = (props: EditMealProps) => {
  const updateMeal = async (
    name: string,
    image: string,
    description: string,
    tastiness: number | null,
    healthiness: number | null,
    ingredients: IngredientInputItem[],
    tags: string[],
    calories: number | null,
    protein: number | null,
    carbs: number | null,
    fat: number | null,
    preparationTime: number | null
  ): Promise<Meal> => {
    const ingredientsPayload = await resolveIngredientIds(ingredients);

    const response = await callApiWithData(
      `/meal/${props.mealToEdit.id}`,
      {
        name,
        image,
        description,
        tastiness,
        healthiness,
        ...(ingredientsPayload.length > 0 ? { ingredients: ingredientsPayload } : {}),
        tags,
        calories,
        protein,
        carbs,
        fat,
        preparationTime,
      },
      'PUT'
    );

    return mapMealFromApi(response.meal);
  };

  const initialIngredients: IngredientInputItem[] = (props.mealToEdit.ingredients ?? []).map((i) =>
    createIngredientInputItem({
      ingredientId: i.id,
      name: i.name,
      quantity: i.quantity,
    })
  );

  return (
    <MealForm
      onMealSave={props.onMealSave}
      submitMeal={updateMeal}
      initialName={props.mealToEdit.name}
      initialDescription={props.mealToEdit.description}
      initialImage={props.mealToEdit.image}
      initialTastiness={props.mealToEdit.tastiness}
      initialHealthiness={props.mealToEdit.healthiness}
      initialIngredients={initialIngredients}
      initialTags={props.mealToEdit.tags.map((t) => t.id)}
      initialCalories={props.mealToEdit.calories}
      initialProtein={props.mealToEdit.protein}
      initialCarbs={props.mealToEdit.carbs}
      initialFat={props.mealToEdit.fat}
      initialPreparationTime={props.mealToEdit.preparationTime}
      getRecipeFromImage={callRecipeFromImageApi}
    ></MealForm>
  );
};

export default EditMeal;
